import React from "react";
import "./VideoGallery.css";

const videos = [
  {
    id: 1,
    // title: "Laser Show",
    src: "./images/gallery/video-1.mp4",
    poster: "./images/gallery/p-1.png"
  },
  {
    id: 2,
    // title: "Event Highlights",
    src: "/images//gallery/video-2.mp4",
   poster: "./images/gallery/p-2.png"
  },
  {
    id: 4,
    // title: "Product Demo",
    src: "/images//gallery/video-4.mp4",
    poster: "./images/gallery/p-4.png"
  },
  {
    id: 5,
    // title: "Product Demo",
    src: "/images//gallery/video-5.mp4",
   poster: "./images/gallery/p-5.png"
  },
  {
    id: 6,
    // title: "Product Demo",
    src: "/images//gallery/video-6.mp4",
   poster: "./images/gallery/p-6.png"
  },
  {
    id: 7,
    // title: "Product Demo",
    src: "/images//gallery/video-7.mp4",
   poster: "./images/gallery/p-7.png"
  },
  {
    id: 8,
    // title: "Product Demo",
    src: "/images//gallery/video-8.mp4",
   poster: "./images/gallery/p-8.png"
  },
  {
    id: 9,
    // title: "Product Demo",
    src: "/images//gallery/video-9.mp4",
   poster: "./images/gallery/p-9.png"
  },
  {
    id: 10,
    // title: "Product Demo",
    src: "/images//gallery/video-10.mp4",
   poster: "./images/gallery/p-10.png"
  },
  {
    id: 11,
    // title: "Product Demo",
    src: "/images//gallery/video-11.mp4",
   poster: "./images/gallery/p-11.png"
  }
];

const VideoGallery = () => {
  return (
    <div className="video-wrapper">
      {videos.map((video) => (
        <div className="video-card" key={video.id}>
          <video
            controls
            preload="metadata"
            poster={video.poster}
          >
            <source src={video.src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <h4>{video.title}</h4>
        </div>
      ))}
    </div>
  );
};

export default VideoGallery;
